export default __webpack_public_path__ + "static/media/trang-chu-2.2ba7e4b0.png";